import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function TermsPage() {
  const { t } = useLanguage();

  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold text-gray-900">
          {t('terms.title')}
        </h1>
        
        <div className="mt-8 prose prose-blue">
          <h2 className="font-bold text-gray-800">{t('terms.scope.title')}</h2>
          <p>{t('terms.scope.content')}</p>

          <h2 className="font-bold text-gray-800">{t('terms.services.title')}</h2>
          <p>{t('terms.services.content')}</p>

          <h2 className="font-bold text-gray-800">{t('terms.pricing.title')}</h2>
          <p>{t('terms.pricing.content')}</p>

          <h2 className="font-bold text-gray-800">{t('terms.payment.title')}</h2>
          <p>{t('terms.payment.content')}</p>

          <h2 className="font-bold text-gray-800">{t('terms.liability.title')}</h2>
          <p>{t('terms.liability.content')}</p>

          <h2 className="font-bold text-gray-800">{t('terms.termination.title')}</h2>
          <p>{t('terms.termination.content')}</p>

          <h2 className="font-bold text-gray-800">{t('terms.jurisdiction.title')}</h2>
          <p>{t('terms.jurisdiction.content')}</p>
        </div>
      </div>
    </div>
  );
}